import {
    DependenciesPayload,
    Subscription,
    VehicleState,
} from '@sxm-de/dev-kits/web-sdk/types';
import { getSubscriptionDetailedState } from './get-subscription-detailed-state';

export async function getSubscriptionAdditionalData(
    {
        subscription,
    }: {
        subscription: Subscription;
    },
    dependencies: DependenciesPayload,
): Promise<{
    detailedState: VehicleState | null;
}> {
    let detailedState = null;

    // Check to see if there is an automotive (device) associated with the subscription
    const deviceBeneficiary = subscription.beneficiaries?.find(
        (beneficiary) => beneficiary.type === 'device',
    );
    if (deviceBeneficiary) {
        detailedState = await getSubscriptionDetailedState(
            {
                subscriptionId: subscription.id,
            },
            dependencies,
        );
    }

    return { detailedState };
}
